/**
 * This will format price to kroner (NOK)
 *
 * @param price - Price to convert to kroner (NOK)
 * @returns Price in kroner (NOK)
 */
export function formatPrice(price) {
    return price ? price / 100 : price;
}
/**
 *
 * @param cardNumber Card number to be formatted
 * @returns A string with four stars and the last four digits of the card number
 * @example getFormattedCardNumber('1234567890123456') // **** 3456
 */
export function getFormattedCardNumber(cardNumber) {
    const lastFourDigits = cardNumber.slice(-4);
    return `**** ${lastFourDigits}`;
}
/**
 *
 * @param ssn Social security number to be formatted
 * @returns A string with the first six digits of the ssn, a space, and the remaining digits of the ssn
 * @example getFormattedSSN('12121255555') // 121212 55555
 */
export function getFormattedSSN(ssn) {
    return `${ssn.slice(0, 6)} ${ssn.slice(6)}`;
}
export function getLowestPrice(services, links) {
    const servicePrices = services.map((service) => service.price);
    const linkPrices = links?.map((link) => parseInt((link.additionalInfo.nb ?? '').replace(',-', '')) * 100) ?? [];
    const allPrices = [...servicePrices, ...linkPrices];
    return Math.min(...allPrices);
}
